import React from 'react'
import { observer } from 'mobx-react'
import { Row, Col } from 'react-bootstrap'
import { i18nTranslate } from 'src/utils'
import ViewCartRefreshIcon from 'src/views/components/Icons/ViewCartRefreshIcon'
import { ImageComponent } from 'src/views/components'
import { transformCartSubscriptionProductData } from '../deps'
import TickIcon from 'src/views/components/Icons/TickIcon'
import './styles.scss'

@observer
class ConfirmationModalProductDetails extends React.Component {
  renderProductSkuDetails = skuId => {
    const skuTitle = i18nTranslate('productCard.sku', 'SKU', {
      isNextGenTranslations: true,
    })
    return (
      <div
        className="subscription-sku-details"
        data-testid="qa-subscription-sku-details">
        <span className="subscription-sku-title">{skuTitle}</span>
        <span className="subscription-sku-colon">:</span>
        <span
          className="subscription-sku-id"
          data-testid="qa-subscription-sku-id">
          {skuId}
        </span>
      </div>
    )
  }

  renderProductDetails = subscriptionItem => {
    return (
      <div
        className="confirmation-product-details"
        data-testid="qa-subscription-confirmation-product-details">
        {this.renderSubscriptionItemLabel()}
        <div
          className="confirmation-product-name"
          data-testid="qa-subscription-confirmation-product-name">
          {subscriptionItem?.productName}
        </div>
        <div
          className="confirmation-product-sku-id"
          data-testid="qa-subscription-confirmation-product-sku-id">
          {this.renderProductSkuDetails(subscriptionItem?.skuId)}
        </div>
      </div>
    )
  }

  renderProductImage = subscriptionItem => {
    const { imageURL = '', productName = '' } = subscriptionItem || {}
    return (
      <div
        className="confirmation-subscription-product-image-wrapper"
        data-testid="qa-confirmation-subscription-product-image-wrapper">
        <ImageComponent
          testid="qa-confirmation-subscription-product-image"
          src={imageURL}
          alt={productName}
          height={'62px'}
          width={'62px'}
        />
        <TickIcon
          className="tick-icon"
          width="20"
          height="20"
          fillColor="#FFFFFF"
          data-testid="tick-icon-icon"
        />
      </div>
    )
  }

  renderSubscriptionItemLabel = () => {
    return (
      <div
        className="confirmation-subscription-item-label"
        data-testid="qa-confirmation-subscription-item-label">
        <span className="confirmation-subscription-icon mr-1">
          <ViewCartRefreshIcon
            className="view-cart-refresh-icon"
            width="9"
            height="9"
            fillColor="#252525"
          />
        </span>
        <span className="confirmation-subscription-item-label-text">
          {i18nTranslate(
            'subscriptionSummaryCard.subscriptionItem',
            'Subscription item',
            { isNextGenTranslations: true }
          )}
        </span>
      </div>
    )
  }

  renderSubscriptionProductDetails = subscriptionItem => {
    const productDetails =
      transformCartSubscriptionProductData(subscriptionItem)

    return (
      <div
        className="confirmation-subscription-product-info"
        data-testid="qa-confirmation-subscription-product-info">
        <Row noGutters className="confirmation-subscription-product-info-row">
          <Col xs={3} sm={3}>
            {this.renderProductImage(productDetails)}
          </Col>
          <Col xs={9} sm={9}>
            {this.renderProductDetails(productDetails)}
          </Col>
        </Row>
      </div>
    )
  }

  render() {
    const { cartSubscriptionList = [] } = this.props

    return cartSubscriptionList?.map((subscriptionItem, index) => {
      return (
        <div
          key={subscriptionItem?.itemId}
          className="confirmation-subscription-product-details-wrapper">
          {this.renderSubscriptionProductDetails(subscriptionItem)}
        </div>
      )
    })
  }
}

export { ConfirmationModalProductDetails }
export default ConfirmationModalProductDetails
